import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './adminAuth'; // N-100: глобальный перехватчик истёкшего admin-токена (401/403 -> /login)
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Doctors from './pages/Doctors';
import DoctorDetail from './pages/DoctorDetail';
import Patients from './pages/Patients';
import PatientDetail from './pages/PatientDetail';
import Clinics from './pages/Clinics';
import ClinicDetail from './pages/ClinicDetail';
import Networks from './pages/Networks';
import NetworkDetail from './pages/NetworkDetail';
import Transactions from './pages/Transactions';
import Commissions from './pages/Commissions';
import OperationCommissions from './pages/OperationCommissions';
import ProfileRequests from './pages/ProfileRequests';
import Notifications from './pages/Notifications';
import Tickets from './pages/Tickets';
import Documents from './pages/Documents';
import ServiceCatalog from './pages/ServiceCatalog';
import PollLog from './pages/PollLog';

function App() {
  const key = localStorage.getItem('adminKey');
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={key ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/doctors" element={key ? <Doctors /> : <Navigate to="/login" />} />
        <Route path="/doctors/:id" element={key ? <DoctorDetail /> : <Navigate to="/login" />} />
        <Route path="/patients" element={key ? <Patients /> : <Navigate to="/login" />} />
        <Route path="/patients/:id" element={key ? <PatientDetail /> : <Navigate to="/login" />} />
        <Route path="/clinics" element={key ? <Clinics /> : <Navigate to="/login" />} />
        <Route path="/clinics/:id" element={key ? <ClinicDetail /> : <Navigate to="/login" />} />
        <Route path="/networks" element={key ? <Networks /> : <Navigate to="/login" />} />
        <Route path="/networks/:id" element={key ? <NetworkDetail /> : <Navigate to="/login" />} />
        <Route path="/transactions" element={key ? <Transactions /> : <Navigate to="/login" />} />
        <Route path="/commissions" element={key ? <Commissions /> : <Navigate to="/login" />} />
        <Route path="/operation-commissions" element={key ? <OperationCommissions /> : <Navigate to="/login" />} />
        <Route path="/profile-requests" element={key ? <ProfileRequests /> : <Navigate to="/login" />} />
        <Route path="/notifications" element={key ? <Notifications /> : <Navigate to="/login" />} />
        <Route path="/tickets" element={key ? <Tickets /> : <Navigate to="/login" />} />
        <Route path="/documents" element={key ? <Documents /> : <Navigate to="/login" />} />
        <Route path="/service-catalog" element={key ? <ServiceCatalog /> : <Navigate to="/login" />} />
        <Route path="/api-log" element={key ? <PollLog /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to={key ? "/dashboard" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;